const monthsOptions = [
    {
        "text": "Months",
        "value": null,
        "disabled": true
    },
    {
        "text": "0 months",
        "value": "0"
    },
    {
        "text": "1 month",
        "value": "1"
    },
    {
        "text": "2 months",
        "value": "2"
    },
    {
        "text": "3 months",
        "value": "3"
    },
    {
        "text": "4 months",
        "value": "4"
    },
    {
        "text": "5 months",
        "value": "5"
    },
    {
        "text": "6 months",
        "value": "6"
    },
    {
        "text": "7 months",
        "value": "7"
    },
    {
        "text": "8 months",
        "value": "8"
    },
    {
        "text": "9 months",
        "value": "9"
    },
    {
        "text": "10 months",
        "value": "10"
    },
    {
        "text": "11 months",
        "value": "11"
    }
];
export default monthsOptions;
